import { t } from '@lingui/macro';

export const faqBusiness = [
    {
        id: 'WhyAcceptCards',
        heading: t`faq.merchant.heading.WhyAcceptCards`,
        content: t`faq.merchant.content.WhyAcceptCards`,
        countries: {
            cz: true,
            es: true,
            it: true,
            sk: true
        }
    },
    {
        id: 'WhyIsTrisbeeBetter',
        heading: t`faq.merchant.heading.WhyIsTrisbeeBetter`,
        content: t`faq.merchant.content.WhyIsTrisbeeBetter`,
        countries: {
            cz: true,
            es: true,
            it: true,
            sk: true
        }
    },
    {
        id: 'HowCustomerPay',
        heading: t`faq.merchant.heading.HowCustomerPay`,
        content: t`faq.merchant.content.HowCustomerPay`,
        countries: {
            cz: true,
            es: true,
            it: true,
            sk: true,
        }
    },
    {
        id: 'IsItRealyFree',
        heading: t`faq.merchant.heading.IsItRealyFree`,
        content: t`faq.merchant.content.IsItRealyFree`,
        countries: {
            cz: false,
            es: true,
            it: true,
            sk: true,
        },
    },
    {
        id: 'IsItRealyFreeCZ',
        heading: t`faq.merchant.heading.IsItRealyFree`,
        content: t`faq.merchant.content.IsItRealyFree.cz`,
        countries: {
            cz: true,
            es: false,
            it: false,
            sk: false,
        },
    },
    {
        id: 'TurnoverCommitment',
        heading: t`faq.merchant.heading.TurnoverCommitment`,
        content: t`faq.merchant.content.TurnoverCommitment`,
        countries: {
            cz: true,
            es: true,
            it: true,
            sk: true,
        }
    },
    {
        id: 'NeedsForRegistration',
        heading: t`faq.merchant.heading.NeedsForRegistration`,
        content: t`faq.merchant.content.NeedsForRegistration`,
        countries: {
            cz: true,
            es: true,
            it: true,
            sk: true,
        }
    },
    {
        id: 'NeedsForAcceptPayment',
        heading: t`faq.merchant.heading.NeedsForAcceptPayment`,
        content: t`faq.merchant.content.NeedsForAcceptPayment`,
        countries: {
            cz: true,
            es: true,
            it: true,
            sk: true,
        }
    },
    {
        id: 'PaymentNotification',
        heading: t`faq.merchant.heading.PaymentNotification`,
        content: t`faq.merchant.content.PaymentNotification`,
        countries: {
            cz: true,
            es: true,
            it: true,
            sk: true,
        }
    },
    {
        id: 'WhenMoney',
        heading: t`faq.merchant.heading.WhenMoney`,
        content: t`faq.merchant.content.WhenMoney`,
        countries: {
            cz: false,
            es: true,
            it: true,
            sk: true,
        },
    },
    {
        id: 'WhenMoneyCZ',
        heading: t`faq.merchant.heading.WhenMoney`,
        content: t`faq.merchant.content.WhenMoney.cz`,
        countries: {
            cz: true,
            es: false,
            it: false,
            sk: false,
        },
    },
    {
        id: 'WhatAboutTips',
        heading: t`faq.merchant.heading.WhatAboutTips`,
        content: t`faq.merchant.content.WhatAboutTips`,
        countries: {
            cz: true,
            es: true,
            it: true,
            sk: true,
        }
    },
];
